import { render, staticRenderFns } from "./CadastroObito.vue?vue&type=template&id=26fcca9e&"
import script from "./CadastroObito.vue?vue&type=script&lang=js&"
export * from "./CadastroObito.vue?vue&type=script&lang=js&"
import style0 from "./CadastroObito.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports